import React from 'react'
import styles from './Table.module.scss'
import { ColumnHeader, SortingDirection } from '../ColumnHeader/ColumnHeader'

interface Props {
  data: any[]
  onSortClick?: (column: string, direction: SortingDirection) => void
  sortingColumn?: string
  sortingDirection?: SortingDirection
}

export default function Table({ data, onSortClick, sortingColumn, sortingDirection }: Props) {
  function formatNumber(number: number) {
    if (!number || Number(number) === 0) {
      return null
    }
    return Intl.NumberFormat('en', { notation: 'compact', currency: 'USD', style: 'currency' }).format(number)
  }

  function formatDate(date: string) {
    if (!date) {
      return null
    }
    return new Date(date).toLocaleDateString('en', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    })
  }

  function createOnSortClick(column: string) {
    return (direction: SortingDirection) => {
      return onSortClick && onSortClick(column, direction)
    }
  }

  return (
    <table className={styles.table} cellPadding={0} cellSpacing={0}>
      <thead>
        <tr>
          <ColumnHeader direction={sortingColumn === 'symbol' ? sortingDirection : undefined}
                        onSortClick={createOnSortClick('symbol')}>Company</ColumnHeader>
          <ColumnHeader direction={sortingColumn === 'ipo_date' ? sortingDirection : undefined}
                        onSortClick={createOnSortClick('ipo_date')}>IPO date</ColumnHeader>
          <ColumnHeader direction={sortingColumn === 'insider_lockup_date' ? sortingDirection : undefined}
                        onSortClick={createOnSortClick('insider_lockup_date')}>Lockup expiration date</ColumnHeader>
          <ColumnHeader direction={sortingColumn === 'market_cap_at_offer' ? sortingDirection : undefined}
                        onSortClick={createOnSortClick('market_cap_at_offer')}>Market cap</ColumnHeader>
        </tr>
      </thead>
      <tbody>
      {data.map(ipo => (
          <tr key={ipo.symbol}>
            <td>
              <span className={styles.symbol}>{ipo.symbol}</span>
              <span className={styles.name}>{ipo.name}</span>
            </td>
            <td>{formatDate(ipo.ipo_date) || '-'}</td>
            <td>{formatDate(ipo.insider_lockup_date) || '-'}</td>
            <td>{formatNumber(ipo.market_cap_at_offer) || '-'}</td>
          </tr>
        ),
      )}
      </tbody>
    </table>
  )
}